import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import Callout from "ds/components/Callout";
import FeedbackActions from "ds/components/Feedback/Actions";
import { getDocsUrl } from "utils/getDocsUrl";

const STORAGE_KEY = "spaceDetailsSessionAccessCalloutClosed";

const SpaceDetailsSessionAccessCallout = () => (
  <Callout variant="info" title="Access comes from live sessions" storageKey={STORAGE_KEY}>
    Your account management strategy is based on login policies, so space access is evaluated when
    someone logs in. These rows show the roles carried by sessions that are live right now. Edit
    your login policies to change who gets access; an account admin can deactivate a session to cut
    off access that already exists.
    <FeedbackActions>
      <ReadMoreDocsLink
        docsUrl={getDocsUrl("/concepts/policy/login-policy.html")}
        title="Learn more about login policies"
      />
    </FeedbackActions>
  </Callout>
);

export default SpaceDetailsSessionAccessCallout;
